import(/* webpackMode: "eager" */ "/tmp/8de756aee570412/app/[locale]/error.tsx");
